module.exports = __webpack_public_path__ + "img/chat_send.b555429c.png";